import React from 'react';
import { Row, Modal } from 'react-bootstrap';
import GetAmericoHealthClass from '../../MCT/Helpers/GetAmericoHealthClass';
import { setSessionStorageItem, SESSION_STORAGE_AMERICO_OBJECT_KEY } from '../../../../sessionStorage';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
    americoModalHighlighted: {
        zIndex:'1400'
    }
}));

export default function AmericoQuoteModel(props) {
    const classes = useStyles();
    const handleAmericoQuoteOnNext = () => {
        var form = { ...props.fullFormState };
        var healthClassValue = GetAmericoHealthClass(props.healthClass);
        var tobacco = props.basicInfo.tobacco === 'true' ? 'Over 36 months' : 'Never';
        const AMERICO_SESSION_STORAGE_KEY = "AMERICO_QUOTE";
        let customData = {
            coverageAmount: props.coverageAmount,
            healthClass: healthClassValue,
            premium: form.pages.quoter.premium,
            term: props.termLength,
            cashValue: form.pages.quoter.cashValue,
            logoUrl: form.pages.quoter.logoUrl,
            backUrl:'/term-insurance/quote-results',
            tobacco : tobacco,
            isFromAmerico : true
        }
        setSessionStorageItem(SESSION_STORAGE_AMERICO_OBJECT_KEY, customData)
        sessionStorage.removeItem(AMERICO_SESSION_STORAGE_KEY);
        props.history.push('/loan-protection/getting-started');
    }
    return (
        <Modal show={props.americoModalShow} className={classes.americoModalHighlighted} onHide={props.handleAmericoModalClose} backdrop="static" centered>
            <Modal.Body className="model-body d-flex align-items-center justify-content-center p-3 flex-column ">
                <p className='model-header'>LoanMatch Protector is a decreasing term product</p>
                <p className='model-content'>Your insurance coverage will decrease over time to match the balance of a loan or other decreasing financial obligation.</p>
                <Row>
                    <div className='pt-2'>
                        <Button variant='contained' size="medium" color="primary" onClick={handleAmericoQuoteOnNext}>Continue</Button>
                    </div>
                </Row>
                <Row className='mt-2'>
                    <div>
                        <Button size="medium" color="primary" onClick={props.handleAmericoModalClose}>Back</Button>
                    </div>
                </Row>
            </Modal.Body>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/QuoterComponents/AmericoQuoteModel.js